import { gql } from "@apollo/client";

export const GET_ORDERS_QUERY = gql`
  query GetOrders(
    $filters: OrdersFilters!
    $pagination: PaginationRequest!
    $sort: [OrderSort!]
    $withOrderItems: Boolean!
  ) {
    order {
      pagination(filters: $filters, sort: $sort, pagination: $pagination) {
        paginationData {
          total
          offset
          limit
        }
        orders {
          id
          createdAt
          number
          total
          orderParcel {
            trackingCode
          }
          subTotal
          customerPaymentMethod
          orderType
          codAmount
          exportedWarehouse {
            name
          }
          receiverContactName
          receiverContactAddress
          orderPriority
          shippingType
          shippingVersion
          paymentMethod
          status
          createdBy {
            fullname
            email
            telephone
          }
          fullStockRequired
          remainingDeliverTime
          vat
          promisedDeliverTime
          deliveryDeadline
          shippingConfiguration {
            busConfig {
              busName
              busStation
              telephone
              location
              fee
            }
            deliver3PartyConfig {
              provider {
                name
                code
              }
              carrierMethod
              name
              weight
              length
              width
              height
              fee
              serviceName
            }
            urbanConfig {
              fee
            }
          }
          internalNote
          stockStatus
          completedAt
          fileURLs
          senderAddress
          shipperTelephone
          shipperName
          receiverContactPhone
          receiverContact {
            tel2
          }
          note
          assemblyRequired
          shippingOrderCode
          items @include(if: $withOrderItems) {
            productCode
            productName
            quantity
            product {
              variantAttributeValues {
                attribute {
                  name
                }
                attributeValue {
                  value
                }
              }
              uom {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_WAREHOUSES = gql`
  query {
    warehouse {
      list {
        warehouses {
          name
          id
        }
      }
    }
  }
`;

export const GET_WAREHOUSES_WITH_IDS = gql`
  query GetWarehouseWithIds($request: WarehouseRequest) {
    warehouse {
      list(request: $request) {
        warehouses {
          name
          id
        }
      }
    }
  }
`;

export const GET_CREATED_BY = gql`
  query GetCreatedBy($pagination: PaginationRequest) {
    user {
      pagination(pagination: $pagination) {
        paginationData {
          total
          offset
          limit
        }
        users {
          id
          email
        }
      }
    }
  }
`;

export const GET_ORDER_DETAIL_QUERY = gql`
  query GetOrder($id: ID!) {
    order {
      get(id: $id) {
        id
        salesMan {
          id
          fullname
        }
        status
        number
        vatTaxIDNumber
        vatCompanyName
        vatEmail
        vatAddress
        items {
          id
          productName
          productCode
          quantity
          price
          customerPrice
          total
          customerTotal
          maxDaysOfDebt
          productWarranty
          inStock
          vat
          product {
            uom {
              name
            }
          }
        }
        sellerID
        seller {
          shortName
          telephone
          address
          debtLimit
          availabilityLimit
          vatInfo {
            address
            email
            taxIDNumber
            businessName
          }
          companyWallet {
            balance
          }
        }
        createdByID
        note
        internalNote
        shippingType
        shippingConfiguration {
          busConfig {
            busName
            telephone
            location
            busStation
            fee
          }
          deliver3PartyConfig {
            name
          }
        }
        orderPriority
        promisedDeliverTime
        deliveryDeadline
        remainingDeliverTime
        fullStockRequired
        shippingFee
        serviceFee
        discount
        exportedWarehouseID
        vat
        discount
        subTotal
        subCustomerTotal
        customerTotal
        senderName
        senderPhone
        senderAddress
        receiverContactName
        receiverContactPhone
        receiverContact {
          tel2
        }
        receiverContactAddress
        total
        totalProduct
        cashPayment
        stockStatus
        paymentMethod
        assemblyRequired
        fileURLs
        fullEvents {
          state
          name
          createdAt
          createdBy {
            fullname
          }
        }
        orderType
        assemblyRequired
        customerPaymentMethod
      }
    }
  }
`;

export const GET_SUMMARY_TABS = gql`
  query GetSummaryTabs {
    order {
      totalByStatus {
        all
        waitingForApprovalStock
        waitingForEnoughStock
        waitingForPayment
        waitingForPackaging
        waitingForExporting
        waitingForAssembly
        waitingForShipping
        delivering
        completed
        canceled
      }
    }
  }
`;

export const GET_CREATED_BY_WITH_IDS = gql`
  query GetCreatedByWithIds($filters: UsersFilters) {
    user {
      pagination(filters: $filters) {
        users {
          id
          email
        }
      }
    }
  }
`;

export const GET_COUNT_ORDER_WITH_FILTERS = gql`
  {
    v1waitingForShippingNotSet: order {
      count(filters: { statuses: [WAITING_FOR_SHIPPING], shippingStatus: null })
    }
    v2waitingForShippingNotSet: order {
      count(filters: { statuses: [WAITING_FOR_SHIPPING], shippingStatus: NOT_SET })
    }
    v1waitingForShippingWaiting: order {
      count(filters: { statuses: [DELIVERING], shippingStatus: WAITING })
    }
    v2waitingForShippingWaiting: order {
      count(filters: { statuses: [WAITING_FOR_SHIPPING], shippingStatus: WAITING })
    }
    allVerWaitingForShippingWaiting: order {
      count(filters: { statuses: [WAITING_FOR_SHIPPING, DELIVERING], shippingStatus: WAITING })
    }
    v1deliveryConfirmPicked: order {
      count(filters: { statuses: [DELIVERING], shippingStatus: CONFIRM_PICKED })
    }
    v2deliveryConfirmPicked: order {
      count(filters: { statuses: [DELIVERING], shippingStatus: null })
    }
    completed: order {
      count(filters: { statuses: [COMPLETED] })
    }
  }
`;
